import styled from "styled-components";

export const Link = styled.a`
    font-weight: 700;
    text-decoration: underline;
    text-underline-offset: 2px;
`;